import Schema from "async-validate";
import "async-validate/plugin/all";
import jsonLogicPlugin from "./plugins/json-logic-plugin.js";
import codiceFiscalePlugin from "./plugins/codice-fiscale-plugin.js";
import messages from "./rule-validator-messages-it.js";
import format from "format-util";
import conditionalRequiredPlugin from "./plugins/required-if-plugin.js";
import lessThenTodayPlugin from "./plugins/today-plugin.js";
import LessThanOrEqualTodayPlugin from "./plugins/today-plugin.js";
import customObject from "./plugins/custom-object.js";
import capPlugin from "./plugins/cap-plugin.js";
import activeRulePlugin from "./plugins/active-rule-plugin.js";

Schema.plugin([
    jsonLogicPlugin,
    codiceFiscalePlugin,
    conditionalRequiredPlugin,
    lessThenTodayPlugin,
    LessThanOrEqualTodayPlugin,
    capPlugin,
    activeRulePlugin,
    customObject
]);

export default class RulesValidator{
    constructor(descriptor){
        this.schema = new Schema(descriptor, { messages: messages });
    }

    validate(model, opts){
        return new Promise((resolve, reject) => {
            opts = opts || {};
            this.schema.validate(model, opts, function(err, res){
                if (err){
                    throw err;
                }
                if (res){
                    return reject(res);
                }
                return resolve();
            });
        });
    }

    static formatMessage(message, args){
        if (!args){
            args = [];
        }
        if (!Array.isArray(this.rule.msgProps)){
            this.rule.msgProps = [this.rule.msgProps];
        }
        let mch = message.match(/(%s)+/g);
        if (!mch) return message;
        let cnt = mch.length;
        args.splice(0, cnt, ...this.rule.msgProps.slice(0, cnt));
        return format(message, ...args.slice(0, cnt));
    }
}
